import React from 'react';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { MobileCallBar } from './components/MobileCallBar';
import { Home } from './pages/Home';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { ui } from './data/ui';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="3fb14re3nnz9s">
      <SiteLayout data-id="element-1" data-mp="3f8f31v3g4dzh" />
    </LanguageProvider>;
}
function SiteLayout() {
  const {
    t
  } = useLanguage();
  return <div className="flex min-h-screen w-full flex-col bg-white pb-14 font-sans text-body lg:pb-0" data-id="element-2" data-mp="2mlubatj25zve">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-white focus:px-4 focus:py-2 focus:text-navy" data-id="element-3" data-mp="31aqeoda66opo">
        {t(ui.skip)}
      </a>
      <Header data-id="element-4" data-mp="28te0v7ntuzkg" />
      <main id="main" className="flex-1" data-id="element-5" data-mp="28t4j27cxrypu">
        <Home data-id="element-6" data-mp="23vcjqs9ypabm" />
      </main>
      <Footer data-id="element-7" data-mp="23w4fc33k781w" />
      <MobileCallBar data-id="element-8" data-mp="23u9q4cl98ts0" />
    </div>;
}